<template>
    <div class="resources-location">
        <h3 class="resources-location__title">{{ props.title }}</h3>
        <MaltImg class="resources-location__image" width="300" :src="props.imageUrl" :alt="props.imageAlt ?? props.title" />
        <slot />
    </div>
</template>
<script setup lang="ts">
    import {MaltImg} from '#components';

    type LocationProps = {
        title: string;
        imageUrl: string;
        imageAlt?: string | null;
        description?: string;
    };
    const props = defineProps<LocationProps>();
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .resources-location {
        border-radius: var(--joy-core-radius-4);
        box-shadow: var(--joy-core-elevation-3);
        border: 1px solid var(--joy-color-neutral-30);
        padding: var(--joy-core-spacing-4);
        display: flex;
        flex-direction: column;
        gap: var(--joy-core-spacing-3);

        &__title {
            font-size: var(--joy-font-size-secondary-200);
            text-align: left;
        }

        &__image {
            border-radius: var(--joy-core-radius-3);
            max-width: 100%;
            margin: 0 auto;
        }
    }
</style>
